namespace gotoAndPlay {

    interface IWidgetSettings {
        toggleClass?: string;
    }

    class Widget {
        element: JQuery;
        settings: IWidgetSettings;
        toggle: JQuery;
        theWidget: JQuery;

        constructor(target: JQuery) {
            this.settings = {
                toggleClass: 'js-load-widget',
            };

            this.element = target;
            this.toggle = this.element.find('.' + this.settings.toggleClass);
            this.theWidget = $('#' + this.toggle.data('target'));

            this.init();
        }

        init(): void {
            this.toggle.on('click', this.loadWidget.bind(this));
        }

        loadWidget(): void {
            this.toggle.hide();
            this.theWidget.show();
            this.theWidget.attr('src', this.theWidget.data('src'));
        }
    }

    $('.widget').each(function() {
        let widget  = new Widget($(this));
    });
}
